import { openAdminUserModal } from "../actions/siteadmin/modalActions";

const privileges = [
    {
        id: 1,
        privilege: 'Manage site settings',
        permittedUrls: [
            '/siteadmin/settings/site'
        ]
    },
    {
        id: 2,
        privilege: 'Homepage settings',
        permittedUrls: [
            '/siteadmin/homepage/banner',
            '/siteadmin/homepage/category',
            '/siteadmin/homepage/topfeature',
            '/siteadmin/homepage/rider',
            '/siteadmin/homepage/driver',
            '/siteadmin/homepage/footer'
        ]
    },
    {
        id: 3,
        privilege: 'Manage riders',
        permittedUrls: [
            '/siteadmin/riders'
        ]
    },
    {
        id: 4,
        privilege: 'Manage drivers',
        permittedUrls: [
            '/siteadmin/drivers'
        ]
    },
    {
        id: 5,
        privilege: 'Manage vehicles',
        permittedUrls: [
            '/siteadmin/vehicles'
        ]
    },
    {
        id: 6,
        privilege: 'Manage categories',
        permittedUrls: [
            '/siteadmin/category'
        ]
    },
    {
        id: 7,
        privilege: 'Manage location',
        permittedUrls: [
            '/siteadmin/location'
        ]
    },
    {
        id: 8,
        privilege: 'Manage fare',
        permittedUrls: [
            '/siteadmin/pricing/list',
            '/siteadmin/fee-category/list'
        ]
    },
    {
        id: 9,
        privilege: 'Manage bookings',
        permittedUrls: [
            '/siteadmin/bookings',
            '/siteadmin/completed-bookings',
            '/siteadmin/cancelled-bookings',
            '/siteadmin/schedule-bookings'
        ]
    },
    // {
    //     id: 10,
    //     privilege: 'Completed Bookings',
    //     permittedUrls: [
    //         '/siteadmin/completed-bookings',
    //     ]
    // },
    // {
    //     id: 11,
    //     privilege: 'Cancelled Bookings',
    //     permittedUrls: [
    //         '/siteadmin/cancelled-bookings'
    //     ]
    // },
    {
        id: 10,
        privilege: 'Ratings',
        permittedUrls: [
            '/siteadmin/ratings'
        ]
    },
    {
        id: 11,
        privilege: 'Manage promo code',
        permittedUrls: [
            '/siteadmin/promo-code/list'
        ]
    },
    {
        id: 12,
        privilege: 'Manage notifications',
        permittedUrls: [
            '/siteadmin/notifications'
        ]
    },
    {
        id: 13,
        privilege: 'Cancel reason',
        permittedUrls: [
            '/siteadmin/cancel-reasons'
        ]
    },
    {
        id: 14,
        privilege: 'Manage payout',
        permittedUrls: [
            '/siteadmin/payout',
            // '/siteadmin/failed-payout/'
            '/siteadmin/manage-payout'
        ]
    },
    {
        id: 15,
        privilege: 'Manage CMS pages',
        permittedUrls: [
            '/siteadmin/staticpage/manage',
            '/siteadmin/contentpage/manage'
        ]
    },
    {
        id: 16,
        privilege: 'Precaution notification',
        permittedUrls: [
            '/siteadmin/precaution-notification'
        ]
    },
    {
        id: 17,
        privilege: 'Manage manual bookings',
        permittedUrls: [
            '/siteadmin/manual-bookings',
            '/siteadmin/manual-bookings/create'
        ]
    },
    {
        id: 18,
        privilege: 'Manage payment gateway',
        permittedUrls: [
            '/siteadmin/payment-gateway'
        ]
    },
    {
        id: 19,
        privilege: 'Manage Tracking',
        permittedUrls: [
            '/siteadmin/tracking'
        ]
    },
    {
        id: 20,
        privilege: 'Manage Currency',
        permittedUrls: [
            '/siteadmin/currency'
        ]
    },
];

export function getAllAdminPrivileges() {
    return privileges;
}

export function getAllAdminPrivilegesId() {
    return privileges.map((item) => item.id);
}

export function validatePrivilege(requestId, permittedPrevileges) {
    return permittedPrevileges && permittedPrevileges.length > 0 && permittedPrevileges.indexOf(requestId) >= 0;
}

export function restrictUrls(requestURL, permittedPrevileges) {
    let findRequestedUrlId = privileges.find((o) => o && o.permittedUrls
        && o.permittedUrls.length > 0 && o.permittedUrls.indexOf(requestURL) >= 0);

    if (findRequestedUrlId) {
        let checkAccess = permittedPrevileges && permittedPrevileges.length
            && permittedPrevileges.indexOf(findRequestedUrlId.id) >= 0;
        if (checkAccess) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}
